<template>
  <div class="product-add" v-if="form.Useragreement">
    <el-form size="small" ref="form" :model="form" label-width="100px">
      <div class="common-form">用户协议</div>
      <el-form-item>
        <Uediter :key="1" :text="form.Useragreement" :config="ueditor.config" id="Useragreement" @contentChange="contentChangeFunc($event,'Useragreement')" />
      </el-form-item>

      <div class="common-form">用户授权协议</div>
      <el-form-item>
        <Uediter :key="2" :text="form.powerBook" :config="ueditor.config" id="powerBook" @contentChange="contentChangeFunc($event,'powerBook')" />
      </el-form-item>

      <div class="common-form">注册协议</div>
      <el-form-item>
        <Uediter :key="3" :text="form.register" :config="ueditor.config" id="register" @contentChange="contentChangeFunc($event,'register')" />
      </el-form-item>

      <div class="common-form">入驻协议</div>
      <el-form-item>
        <Uediter :key="4" :text="form.settled" :config="ueditor.config" id="settled" @contentChange="contentChangeFunc($event,'settled')" />
      </el-form-item>

      <div class="common-form">代办服务协议</div>
      <el-form-item>
        <Uediter :key="5" :text="form.daiban" :config="ueditor.config" id="daiban" @contentChange="contentChangeFunc($event,'daiban')" />
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

  </div>
</template>

<script>
import SettingApi from '@/api/setting.js';
import Uediter from '@/components/UE.vue';

import { formatModel } from '@/utils/base.js';
export default {
  components: {
    Uediter
  },

  data() {
    return {
      /*是否正在加载*/
      loading: false,
      form: {
        Useragreement:'',
        powerBook:'',
        register:'',
        settled:'',
        daiban:''
      },
      ueditor: {
          config: {
              initialFrameWidth: 600,
              initialFrameHeight: 500
          },
      },
    };
  },
  created() {
    this.getParams()
  },

  methods: {
    /*获取配置数据*/
    getParams() {
      let self = this;
      SettingApi.getAgreement({}, true).then(res => {
        self.form = res.data
        self.loading = false;
      })
        .catch(error => {
          // console.log(error);
        });

    },

    contentChangeFunc(e,name) {
      this.form[name] = e
    },


    /*提交*/
    onSubmit() {
      let self = this;
      let params = self.form;
     console.log(params)

          self.loading = true;
          SettingApi.setAgreement(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '设置成功',
                type: 'success'
              });

            })
            .catch(error => {
              self.loading = false;
            });


    },


  }

};
</script>
<style>
.tips {
  color: #ccc;
}

.avatar-uploader {
  margin: 0 0 30px 150px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  /* height: 178px; */
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/agreement/index.vue